var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render)?_c('div',[_vm._t("default",null,{"filteredCategories":_vm.filteredCategories})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }